import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/chevron-right.svg'


const _withScopeId = n => (_pushScopeId("data-v-c290659c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quizz-justification" }
const _hoisted_2 = { class: "text-lg justification-title" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "text-md" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-takeda",
  src: _imports_0
}, null, -1))

import { QuizzJustification, QuizzType } from '@/types/Quizz'
import { computed, ref } from '@vue/reactivity'
import ReferencesModal from '../ReferencesModal.vue'
import { quizzQcmReferences, quizzIllustrationReferences } from '@/data/quizz'


export default /*#__PURE__*/_defineComponent({
  props: {
    quizzType: null,
    justification: null
  },
  setup(__props: any) {

const props = __props as {
  quizzType: QuizzType
  justification: QuizzJustification
}



const referencesModal = ref<InstanceType<typeof ReferencesModal> | null>(null)

const references = computed(() => {
  let quizzReferences: { [key: string]: string } = {}

  switch (props.quizzType) {
    case QuizzType.QCM:
      quizzReferences = quizzQcmReferences
      break

    case QuizzType.ILLUSTRATION:
      quizzReferences = quizzIllustrationReferences
  }

  const ref =
    props.justification.references?.map((referenceIndex) => {
      return quizzReferences[referenceIndex]
    }) ?? []

  return ref
})

function showReferences() {
  referencesModal.value?.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('general.justification')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.justification.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (typeof item === 'string')
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "text-lg",
              innerHTML: _ctx.$t(item)
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (listItem, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "text-lg",
                  key: index,
                  innerHTML: _ctx.$t(listItem)
                }, null, 8, _hoisted_5))
              }), 128))
            ]))
      ]))
    }), 128)),
    _createElementVNode("button", {
      class: "btn btn-empty btn-references",
      onClick: showReferences
    }, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('general.seeReferences')), 1),
      _hoisted_7
    ]),
    _createVNode(ReferencesModal, {
      ref_key: "referencesModal",
      ref: referencesModal,
      references: _unref(references)
    }, null, 8, ["references"])
  ]))
}
}

})